import { createContext, useContext } from "react"

import type { PublicPresentationDto } from "~/api/dto/public-presentation.dto"

export const PublicPresentationContext =
  createContext<PublicPresentationDto | null>(null)
export const usePublicPresentation = (): PublicPresentationDto | null =>
  useContext(PublicPresentationContext)
